"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 340px;\n  padding: 10px;\n  border: 1px solid ", ";\n  border-radius: 3px;\n\n  .input-name-header,\n  .table-row-text {\n    color: ", ";\n  }\n  .gray-table-row {\n    background-color: ", ";\n  }\n"])), _variables.GlobalColors.s2, function (_ref) {
  var darkMode = _ref.darkMode;
  return darkMode && _variables.GlobalColors.s1;
}, function (_ref2) {
  var darkMode = _ref2.darkMode;
  return darkMode && _variables.GlobalColors.s5;
});

exports.Container = Container;